import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useLocation, useNavigate } from "react-router-dom";
import { TagInput } from "rsuite";
import { useState } from "react";
import { useFormik } from "formik";
import { generateValidationSchema } from "./Validations";
import { useAdddoctorMutation, useLazyGetdoctorQuery } from "../State/Api/AdddocApiSlice";


function AddDoctor() {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-CA'); 
  };
  const navigate = useNavigate();
  const params = useLocation();


  const doctorId = params?.state?.id;
 
  const [fetchDoctor, { data: doctorData, isFetching, failed }] = useLazyGetdoctorQuery();
  const [image, setImage] = useState("/Images/Photo.svg");
  const [imageFile, setImageFile] = useState(null);
  const [adddoctor, { isSuccess, isError, isLoading, error }] =
    useAdddoctorMutation();
  useEffect(() => {
      if (doctorId) {
        fetchDoctor(doctorId);
      }
    }, [doctorId]);
  const clinicUserId = localStorage.getItem("userClinicID");
  const formFields = [
    "email",
    "fullname",
    "gender",
    "dateofbirth",
    "phonenumber",
    "address",
    "emergencycontactnumber",
    "specialization",
    "yearsofexperience",
    "medicallicensenumber",
    "professionalaffiliations",
    "consultationdays",
    "availablehours",
    "oncallavailability",
    "preferredappointmentduration",
    "languagesknown",
    "starttime",
    "endtime",
    "monthly",
    "weekly",
    "days",
    "medicalschlattended",
    "degreesearned",
    "additionalcertification",
    "residencydetails",
    "qualification",
    "primaryrole",
    "subspecility",
    "procedureperformed",
  ];
  const validationSchema = generateValidationSchema(formFields);
  const formik = useFormik({
    initialValues: {
      userclinicid: clinicUserId,
      email: "",
      fullname: "",
      gender: "",
      dateofbirth: "",
      phonenumber: "",
      address: "",
      emergencycontactnumber: "",
      specialization: "",
      yearsofexperience: "",
      medicallicensenumber: "",
      professionalaffiliations: "",
      consultationdays: "",
      availablehours: "",
      oncallavailability: "",
      preferredappointmentduration: "",
      languagesknown: "",
      starttime: "",
      endtime: "",
      monthly: "",
      weekly: "",
      days: "",
      medicalschlattended: "",
      degreesearned: "",
      additionalcertification: "",
      residencydetails: "",
      qualification: "",
      primaryrole: "",
      subspecility: "",
      procedureperformed: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => handleSubmit(values),
  });

  const normalizeArrayField = (value) =>
    Array.isArray(value) ? value : (value?.split(",") || []);
  
  useEffect(() => {
      if (doctorData) {
        formik.setValues({
          
          email: doctorData?.basicinfo?.emailaddress || "",
          fullname: doctorData?.basicinfo?.fullname || "",
          phonenumber: doctorData?.basicinfo?.phonenumber || "",
          gender: doctorData?.basicinfo?.gender || "",    
          dateofbirth: formatDate(doctorData?.basicinfo.dateofbirth) || "",
          address: doctorData?.basicinfo.office_clinicaddress || "",
          emergencycontactnumber: doctorData?.basicinfo.emergencycontactnumber || "",
          // imageFile: doctorData?.basicinfo?.imageURL || "",
          
          specialization: doctorData?.professionalinfo?.specialization || "",
          yearsofexperience: doctorData?.professionalinfo?.yearsofexperience || "",
          medicallicensenumber: doctorData?.professionalinfo?.medicallicensenumber || "",
          professionalaffiliations: doctorData?.professionalinfo?.professionalaffiliations || "",
          consultationdays: doctorData?.professionalinfo?.consultationdays || "",
          availablehours: doctorData?.professionalinfo?.availablehours || "",
          oncallavailability: doctorData?.professionalinfo?.oncallavailability || "",
          preferredappointmentduration: doctorData?.professionalinfo?.preferredappointmentduration || "",
          languagesknown: doctorData?.professionalinfo?.languagesknown || "",
          starttime: doctorData?.professionalinfo?.starttime || "",
          endtime: doctorData?.professionalinfo?.endtime || "",
          monthly: doctorData?.professionalinfo?.monthly || "",
          weekly: doctorData?.professionalinfo?.weekly || "",
          days: doctorData?.professionalinfo?.days || "",


          medicalschlattended: doctorData?.eductioncertificates?.medicalschoolattended || "",
          degreesearned: doctorData?.eductioncertificates?.degreesearned || "",
          additionalcertification: doctorData?.eductioncertificates?.additionalcertifications || "",
          residencydetails: doctorData?.eductioncertificates?.residencydetails || "",
          qualification: normalizeArrayField(doctorData?.eductioncertificates?.qualification) ,

          primaryrole: doctorData?.clinicalrole?.primaryrole || "",
          subspecility: doctorData?.clinicalrole?.subspecialty || "",
          procedureperformed: doctorData?.clinicalrole?.proceduresperformed || "",

        });
        if (doctorData?.basicinfo?.imageURL) {
          setImage(doctorData?.basicinfo?.imageURL);      
          setImageFile(doctorData?.basicinfo?.imageURL); 
        }
      }
    }, [doctorData]);

  const handleSubmit = async (values) => {
    
    const formdata = new FormData();
    formdata.append("basicinfo.emailaddress", values.email);
    // formdata.append("basicinfo.ImageURL", image);
    formdata.append("basicinfo.userclinicid", values.userclinicid);
    formdata.append("basicinfo.ImageURL", imageFile);
    formdata.append("basicinfo.fullname", values.fullname);
    formdata.append("basicinfo.gender", values.gender);
    formdata.append("basicinfo.dateofbirth", values.dateofbirth);
    formdata.append("basicinfo.phonenumber", values.phonenumber);
    formdata.append("basicinfo.office_clinicaddress", values.address);
    formdata.append(
      "basicinfo.emergencycontactnumber",
      values.emergencycontactnumber
    );
    formdata.append("professionalinfo.specialization", values.specialization);
    formdata.append(
      "professionalinfo.yearsofexperience",
      values.yearsofexperience
    );
    formdata.append(
      "professionalinfo.medicallicensenumber",
      values.medicallicensenumber
    );
    formdata.append(
      "professionalinfo.professionalaffiliations",
      values.professionalaffiliations
    );
    formdata.append(
      "professionalinfo.consultationdays",
      values.consultationdays
    );
    formdata.append("professionalinfo.availablehours", values.availablehours);
    formdata.append(
      "professionalinfo.oncallavailability",
      values.oncallavailability
    );
    formdata.append(
      "professionalinfo.preferredappointmentduration",
      values.preferredappointmentduration
    );
    formdata.append("professionalinfo.languagesknown", values.languagesknown);
    formdata.append("professionalinfo.starttime", values.starttime);
    formdata.append("professionalinfo.endtime", values.endtime);
    formdata.append("professionalinfo.monthly", values.monthly);
    formdata.append("professionalinfo.weekly", values.weekly);
    formdata.append("professionalinfo.days", values.days);
    formdata.append("professionalinfo.clinicuserid", "string");
    formdata.append("professionalinfo.doctorid", "string");
    formdata.append("professionalinfo.useruniqueid", "string");
    formdata.append("professionalinfo.userclinicid", values.userclinicid);

    formdata.append(
      "eductioncertificates.medicalschoolattended",
      values.medicalschlattended
    );
    formdata.append("eductioncertificates.degreesearned", values.degreesearned);
    formdata.append(
      "eductioncertificates.additionalcertifications",
      values.additionalcertification
    );
    formdata.append(
      "eductioncertificates.residencydetails",
      values.residencydetails
    );
    formdata.append("eductioncertificates.qualification", values.qualification);
    formdata.append("clinicalrole.primaryrole", values.primaryrole);
    formdata.append("clinicalrole.subspecialty", values.subspecility);
    formdata.append(
      "clinicalrole.proceduresperformed",
      values.procedureperformed
    );
    formdata.append("clinicalrole.userclinicid", values.userclinicid);

    formdata.append("basicinfo.clinicuserid", "string");

    formdata.append("eductioncertificates.clinicuserid", "string");
    formdata.append("eductioncertificates.doctorid", "string");
    formdata.append("eductioncertificates.useruniqueid", "string");
    formdata.append("eductioncertificates.userclinicid", values.userclinicid);

    // basicinfo.clinicuserid

    for (let [key, value] of formdata.entries()) {

    }
    try {
      if (formdata) {
        const result = await adddoctor(formdata).unwrap();
      
        navigate("/Doctors");
      }
    } catch (erro) {}
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
      setImageFile(file);
    }
  };

  return (
    <>
      <main className="ms-2 p-2">
        <div style={{ width: "100%", height: "100%" }}>
          <div className="row bg-white p-2 rounded-2">
            <div className="col-12 mb-2">
              <h4 className="m-0 mt-2 ml-2" style={{ color: "#000" }}>
                {doctorId? "Update Doctor Details":"Add Doctor Details"}
              </h4>
            </div>

            <div className="row mt-3">
              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Basic Doctor Information
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-12 mb-2 mt-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Full Name
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                id="fullname"
                                name="fullname"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.fullname}
                              />
                              {formik.touched.fullname &&
                              formik.errors.fullname ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.fullname}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Gender
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                id="gender"
                                name="gender"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.gender}
                              >
                                <option value="" disabled hidden>
                                  Select Gender
                                </option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                              {formik.touched.gender && formik.errors.gender ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.gender}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Date of Birth
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                id="dateofbirth"
                                name="dateofbirth"
                                type="date"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.dateofbirth}
                                format='dd-mmm-yyyy'
                              />
                              {formik.touched.dateofbirth &&
                              formik.errors.dateofbirth ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.dateofbirth}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Phone Number
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="phonenumber"
                                id="phonenumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.phonenumber}
                              />
                              {formik.touched.phonenumber &&
                              formik.errors.phonenumber ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.phonenumber}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Email Address
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="email"
                                name="email"
                                id="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email}
                              />
                              {formik.touched.email && formik.errors.email ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.email}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Office/Clinic Address
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="address"
                                id="address"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.address}
                              />
                              {formik.touched.address &&
                              formik.errors.address ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.address}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Emergency Contact Number
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="emergencycontactnumber"
                                id="emergencycontactnumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.emergencycontactnumber}
                              />
                              {formik.touched.emergencycontactnumber &&
                              formik.errors.emergencycontactnumber ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.emergencycontactnumber}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-6 d-flex align-items-center">
                      <div className="row">
                        <div className="col-12 d-flex justify-content-center">
                          <div>
                            <img className="img-fluid p-2 d-flex justify-content-right" src="/Images/Photo.svg" alt="" />
                            <div className=" d-flex ml-3 mt-3">
                              <input type="file" name="Upload" id="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="col-6 d-flex align-items-center">
                      <div className="row">
                        <div className="col-12 d-flex justify-content-center">
                          <div>
                            <img
                              className="img-fluid p-2 d-flex justify-content-right h-75 w-75"
                              src={image}
                              alt="Uploaded Preview"
                            />
                            <div className="d-flex ml-3 mt-3">
                              <input type="file" onChange={handleImageChange} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Professional Details
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-12 mb-2 mt-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Specialization
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                id="specialization"
                                name="specialization"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.specialization}
                              >
                                <option value="" disabled hidden>
                                  Choose . . . . .
                                </option>
                                <option value="Cardiologist">
                                  Cardiologist
                                </option>
                                <option value="Dentist">Dentist</option>
                                <option value="General Physician">
                                  General Physician
                                </option>
                                <option value="Orthopedic">Orthopedic</option>
                                <option value="Cardiologist">
                                  Cardiologist
                                </option>
                                <option value="Dermatologist">
                                  Dermatologist
                                </option>
                                <option value="Endocrinologist">
                                  Endocrinologist
                                </option>
                                <option value="Gastroenterologist">
                                  Gastroenterologist
                                </option>
                                <option value="Neurologist">Neurologist</option>
                                <option value="Orthopedic Surgeon">
                                  Orthopedic Surgeon
                                </option>
                                <option value="Pediatrician">
                                  Pediatrician
                                </option>
                                <option value="Psychiatrist">
                                  Psychiatrist
                                </option>
                                <option value="Pulmonologist">
                                  Pulmonologist
                                </option>
                                <option value="Urologist">Urologist</option>
                                <option value="Gynecologist & Obstetrician">
                                  Gynecologist & Obstetrician
                                </option>
                                <option value="Ophthalmologist">
                                  Ophthalmologist
                                </option>
                                <option value="Otolaryngologist (ENT Specialist)">
                                  Otolaryngologist (ENT Specialist)
                                </option>
                                <option value="Oncologist">Oncologist</option>
                              </select>
                              {formik.touched.specialization &&
                              formik.errors.specialization ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.specialization}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Years of Experience
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="yearsofexperience"
                                id="yearsofexperience"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.yearsofexperience}
                              />
                              {formik.touched.yearsofexperience &&
                              formik.errors.yearsofexperience ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.yearsofexperience}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Medical License Number
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="medicallicensenumber"
                                id="medicallicensenumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.medicallicensenumber}
                              />
                              {formik.touched.yearsofexperience &&
                              formik.errors.medicallicensenumber ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.medicallicensenumber}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Professional Affiliations
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="professionalaffiliations"
                                id="professionalaffiliations"
                                placeholder="e.g., member of a medical board"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.professionalaffiliations}
                              />
                              {formik.touched.professionalaffiliations &&
                              formik.errors.professionalaffiliations ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.professionalaffiliations}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Consultation Days
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="consultationdays"
                                id="consultationdays"
                                placeholder=""
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.consultationdays}
                              />
                              {formik.touched.consultationdays &&
                              formik.errors.consultationdays ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.consultationdays}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between mb-3">
                            <Form.Label className="mb-0 ms-4">
                              Available Hours
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="availablehours"
                                id="availablehours"
                                placeholder=""
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.availablehours}
                              />
                              {formik.touched.availablehours &&
                              formik.errors.availablehours ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.availablehours}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="row">
                        <div className="col-12 mb-2 mt-3">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Availability
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                name="oncallavailability"
                                id="oncallavailability"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.oncallavailability}
                              >
                                <option value="" disabled hidden>
                                  Select
                                </option>
                                <option value="available">Available</option>
                                <option value="unavailable">Unavailable</option>
                              </select>
                              {formik.touched.oncallavailability &&
                              formik.errors.oncallavailability ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.oncallavailability}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Preferred Appointment Duration
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="preferredappointmentduration"
                                id="preferredappointmentduration"
                                placeholder=""
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={
                                  formik.values.preferredappointmentduration
                                }
                              />
                              {formik.touched.preferredappointmentduration &&
                              formik.errors.preferredappointmentduration ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.preferredappointmentduration}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Languages Known
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="text"
                                name="languagesknown"
                                id="languagesknown"
                                placeholder=""
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.languagesknown}
                              />
                              {formik.touched.languagesknown &&
                              formik.errors.languagesknown ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.languagesknown}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Start Time
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="time"
                                name="starttime"
                                id="starttime"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.starttime}
                              />
                              {formik.touched.starttime &&
                              formik.errors.starttime ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.starttime}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              End Time
                            </Form.Label>
                            <div>
                              <input
                                className="div-LableInput"
                                type="time"
                                name="endtime"
                                id="endtime"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.endtime}
                              />
                              {formik.touched.endtime &&
                              formik.errors.endtime ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.endtime}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Monthly
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                name="monthly"
                                id="monthly"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.monthly}
                              >
                                <option value="" disabled hidden>
                                  Monthly
                                </option>
                                <option value="January">January</option>
                                <option value="February">February</option>
                                <option value="March">March</option>
                                <option value="April">April</option>
                                <option value="May">May</option>
                                <option value="June">June</option>
                                <option value="July">July</option>
                                <option value="August">August</option>
                                <option value="September">September</option>
                                <option value="October">October</option>
                                <option value="November">November</option>
                                <option value="December">December</option>
                              </select>
                              {formik.touched.monthly &&
                              formik.errors.monthly ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.monthly}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">
                              Weekly
                            </Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                name="weekly"
                                id="weekly"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.weekly}
                              >
                                <option value="" disabled hidden>
                                  Weekly
                                </option>
                                <option value="Week One">Week One</option>
                                <option value="Week Two">Week Two</option>
                                <option value="Week Three">Week Three</option>
                                <option value="Week Four">Week Four</option>
                                <option value="Week Five">Week Five</option>
                              </select>
                              {formik.touched.weekly && formik.errors.weekly ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.weekly}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="d-flex p-2 align-items-center justify-content-between">
                            <Form.Label className="mb-0 ms-4">Days</Form.Label>
                            <div>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                name="days"
                                id="days"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.days}
                              >
                                <option value="" disabled hidden>
                                  Days
                                </option>
                                <option value="Monday">Monday</option>
                                <option value="Tuesday">Tuesday</option>
                                <option value="Wednesday">Wednesday</option>
                                <option value="Thursday">Thursday</option>
                                <option value="Friday">Friday</option>
                                <option value="Saturday">Saturday</option>
                                <option value="Sunday">Sunday</option>
                              </select>
                              {formik.touched.days && formik.errors.days ? (
                                <div
                                  style={{ fontSize: "0.8rem", color: "red" }}
                                  className="lbl-P9urEIgWf1 mt-1"
                                >
                                  {formik.errors.days}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12 col-lg-6 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Education and Certifications
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-12 mb-2 mt-3">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Medical School Attended
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="medicalschlattended"
                            id="medicalschlattended"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.medicalschlattended}
                          />
                          {formik.touched.medicalschlattended &&
                          formik.errors.medicalschlattended ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.medicalschlattended}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Degrees Earned
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="degreesearned"
                            id="degreesearned"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.degreesearned}
                          />
                          {formik.touched.degreesearned &&
                          formik.errors.degreesearned ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.degreesearned}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between mb-3">
                        <Form.Label className="mb-0 ms-4">
                          Additional Certifications
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="additionalcertification"
                            id="additionalcertification"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.additionalcertification}
                          />
                          {formik.touched.additionalcertification &&
                          formik.errors.additionalcertification ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.additionalcertification}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between mb-3">
                        <Form.Label className="mb-0 ms-4">
                          Residency Details
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="residencydetails"
                            id="residencydetails"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.residencydetails}
                          />
                          {formik.touched.residencydetails &&
                          formik.errors.residencydetails ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.residencydetails}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between mb-3">
                        <Form.Label className="mb-0 ms-4">
                          Qualification
                        </Form.Label>
                        <div>
                          <TagInput
                            style={{ width: 250, height: 150 }}
                            name="qualification"
                            id="qualification"
                            onChange={(tags) =>
                              formik.setFieldValue("qualification", tags || [])
                            } // Ensure tags is always an array
                            onBlur={formik.handleBlur}
                            value={formik.values.qualification ?? []}
                          />
                          {formik.touched.qualification &&
                          formik.errors.qualification ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.qualification}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6 col-md-12 col-sm-12">
                <div
                  className="card border-0 shadow-sm mb-3"
                  style={{
                    padding: "0px",
                    borderRadius: ".7rem .7rem 0px 0px",
                  }}
                >
                  <div
                    className=" mb-2 div-bU5sobus9t text-center"
                    style={{
                      backgroundColor: "#005C5B",
                      padding: ".3rem 0px",
                      borderRadius: ".7rem .7rem 0px 0px",
                    }}
                  >
                    <h6
                      className="m-0"
                      style={{ color: "#fff", letterSpacing: ".5px" }}
                    >
                      Clinical Roles
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-12 mb-2 mt-3">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Primary Role
                          <span style={{ color: "grey" }}>*</span>
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="primaryrole"
                            id="primaryrole"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.primaryrole}
                          />
                          {formik.touched.primaryrole &&
                          formik.errors.primaryrole ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.primaryrole}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Subspecialty
                          <span style={{ color: "grey" }}>*</span>
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="subspecility"
                            id="subspecility"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.subspecility}
                          />
                          {formik.touched.subspecility &&
                          formik.errors.subspecility ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.subspecility}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex p-2 align-items-center justify-content-between">
                        <Form.Label className="mb-0 ms-4">
                          Procedures Performed
                        </Form.Label>
                        <div>
                          <input
                            className="div-LableInput"
                            type="text"
                            name="procedureperformed"
                            id="procedureperformed"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.procedureperformed}
                          />
                          {formik.touched.procedureperformed &&
                          formik.errors.procedureperformed ? (
                            <div
                              style={{ fontSize: "0.8rem", color: "red" }}
                              className="lbl-P9urEIgWf1 mt-1"
                            >
                              {formik.errors.procedureperformed}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
              <div className="d-flex gap-3">
                <button className="div-ButtonGrey" type="button">
                  Cancel
                </button>

                <button
                  className="div-ButtonGreen"
                  type="button"
                  onClick={formik.handleSubmit}
                >
                  {doctorId? "Update":"Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default AddDoctor;
